import React, { useState } from 'react'
import { ActivityTypeManager } from '@/shared/ui'
import { 
  useActivityTypesList, 
  useCreateActivityType, 
  useUpdateActivityType, 
  useDeleteActivityType,
  usePagination 
} from '@/shared/hooks'
import type { ActivityTypeCreateRequest, ActivityTypeUpdateRequest } from '@/shared/api/types'

export const ActivityTypesPage: React.FC = () => {
  const [search, setSearch] = useState('')
  const { page, limit, setPage } = usePagination()
  
  const { data, isLoading, error } = useActivityTypesList({
    page,
    limit,
    search: search || undefined,
    include_inactive: false
  })
  
  const createActivityType = useCreateActivityType()
  const updateActivityType = useUpdateActivityType()
  const deleteActivityType = useDeleteActivityType()

  const handleCreate = (
    name: string, 
    isActive?: boolean, 
    sortOrder?: number, 
    allowsMultiselect?: boolean
  ) => {
    const request: ActivityTypeCreateRequest = {
      name,
      is_active: isActive,
      sort_order: sortOrder,
      allows_multiselect: allowsMultiselect
    }
    createActivityType.mutate(request)
  }

  const handleUpdate = (
    id: number, 
    name?: string, 
    isActive?: boolean, 
    sortOrder?: number, 
    allowsMultiselect?: boolean
  ) => {
    const request: ActivityTypeUpdateRequest = {
      name,
      is_active: isActive,
      sort_order: sortOrder,
      allows_multiselect: allowsMultiselect
    }
    updateActivityType.mutate({ id, request })
  }

  const handleDelete = (id: number) => {
    deleteActivityType.mutate(id)
  }

  return (
    <ActivityTypeManager
      title="Виды деятельности"
      description="Управление видами деятельности для курьеров"
      data={data?.items || []}
      loading={isLoading}
      error={error}
      includeInactive={false}
      onToggleInactive={undefined}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      isCreating={createActivityType.isPending}
      isUpdating={updateActivityType.isPending}
      isDeleting={deleteActivityType.isPending}
    />
  )
}
